module.exports = __webpack_public_path__ + "static/img/p-1010283-copy@2x.04345b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/p-1010283-copy@2x.png
// module id = klIV
// module chunks = 12